import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import headerActions from 'actions/headerActions';

export const withHeaderContext = WrappedComponent => {
    const HeaderContextWrapper = (props) => {
        return (
            <WrappedComponent
                {...props}
            />
        );
    };

    return connect(
        state => ({
            headerState: state.header,
        }),
        dispatch => ({
            headerActions: bindActionCreators(headerActions, dispatch),
        }),
    )(HeaderContextWrapper);
};
